import { useEffect } from "react";

/**
 * Sets document.title and (optionally) the meta description tag for the current page.
 * Restores previous values on unmount to avoid stale state.
 */
export default function useDocumentTitle(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");

    if (title) document.title = title;
    if (description && meta) meta.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (meta && prevDesc != null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
